import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import { fetchPrefectures } from '../../../services/personProfiles';
import { Prefecture } from '../../../types/personShow';
import { scrollToElementById } from '../../../libs/scrollUtils';

type Props = {
  onChangedBody: (name: string, value: string) => void;
  location: string;
  target: string;
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  location,
  target,
}) => {
  const [prefectures, setPrefectures] = useState<Prefecture[]>([]);

  const suggestPrefectures: Prefecture[] = [
    { id: 1, name: '北海道' },
    { id: 13, name: '東京都' },
    { id: 14, name: '神奈川県' },
    { id: 11, name: '埼玉県' },
    { id: 12, name: '千葉県' },
    { id: 23, name: '愛知県' },
    { id: 27, name: '大阪府' },
    { id: 40, name: '福岡県' }
  ];

  useEffect(() => {
    const request = async () => {
      try {
        const response = await fetchPrefectures();
        setPrefectures(response.prefectures);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, []);

  const handleChange = (value: string) => {
    if (value === '選択しない') {
      onChangedBody(target, '');
    } else {
      onChangedBody(target, value);
      const prefecture = prefectures.find((pref) => pref.name === value);
      if (prefecture) {
        scrollToElementById(`person_show_modal_location_${prefecture.id}`, 'smooth', 'center');
      }
    }
  };

  return (
    <Presentation
      location={location}
      suggestPrefectures={suggestPrefectures}
      prefectures={prefectures}
      handleChange={handleChange}
    />
  );
};
